import { Link, useLocation, useNavigate } from "react-router-dom"
import { ReactComponent as ArrowRight } from '../../../../assets/images/icon/arrow-right.svg'
import { Divider, Flex } from "antd"
import { MemberBenefitInfo, BasicInfoRow } from "../../../../shared"
import { setUrl } from "../../../../service"

const MyBeforeLogin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const LonginLinkonClick = () => {
        setUrl(location.pathname);
    }
    return (
        <>
            <div style={{ paddingInline: 'var(--space20)' }}>
                <div style={{ marginTop: 32 }}>
                    <Link
                        to="/login"
                        className="sub-title/st4 base/black"
                        style={{ textDecoration: 'none', display: "flex", alignItems: "center", gap: 4 }}
                        onClick={LonginLinkonClick}>
                        로그인 · 회원가입 <ArrowRight width={16} height={16} stroke="#AEAEAE" />
                    </Link>
                </div>
                <Flex style={{ justifyContent: 'space-between', textAlign: 'left', marginTop: 24 }}>
                    <div style={{ width: '100%' }}>
                        <MemberBenefitInfo title="멤버십" value={"-"} to={'/member-ship'} styles={{ icon: { margin: 0 } }} />
                    </div>
                    <div style={{ width: '100%' }}>
                        <MemberBenefitInfo title={<>포인트<span style={{ lineHeight: "16px", padding: "0px 3px" }}>·</span> 쿠폰</>} value={"-"} to={'/my/reward'} styles={{ icon: { margin: 0 } }} />
                    </div>
                </Flex>
                <div style={{ marginTop: 40 }}>
                    <BasicInfoRow title={"정기권 구매"} onClick={() => navigate("/wellness-ticket-group")} styles={{ container: { padding: '12px 0px' }, arrowRight: { padding: 8 } }} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <BasicInfoRow title={"공지사항"} onClick={() => navigate("/notice")} styles={{ container: { padding: '12px 0px' }, arrowRight: { padding: 8 } }} />
                </div>
            </div>
        </>
    )
}
export { MyBeforeLogin }
